export const HomeDetails = [
  {
    img: "https://static1.lenskart.com/media/desktop/img/Apr22/a2.png",
    caption: "Slide 1",
    title: "Eyeglasses",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Apr22/b2.png",
    caption: "Slide 2",
    title: "Sunglasses",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Apr22/d2.png",
    caption: "Slide 3",
    title: "Computer Glasses",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Apr22/d.png",
    caption: "Slide 4",
    title: "Contact lenses",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Apr22/e2.png",
    caption: "Slide 4",
    title: "Power Sunglases",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/June22/prog11.jpg",
    caption: "Slide 4",
    title: "Progressive Lenses",
  },
];

export const HomeDetails1 = [
  {
    img: "https://static1.lenskart.com/media/desktop/img/Dec22/blend-edit/web.jpg",
    caption: "Slide 1",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Nov22/airplay/desk-play.jpg",
    caption: "Slide 2",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Nov22/LK-Airflex-desktop-banner.gif",
    caption: "Slide 3",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Nov22/tinted/launch-desk.gif",
    caption: "Slide 4",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Oct22/kiara/Refresh-Banner-Web.gif",
    caption: "Slide 5",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Nov22/mens-edit/desktop.jpg",
    caption: "Slide 1",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Oct22/at/web.jpg",
    caption: "Slide 2",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Nov22/trans1.gif",
    caption: "Slide 3",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Jan23/23jan/hooper/hooper-web.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Dec22/1-Dec/Homepage-Banner-web.gif",
    caption: "Slide 5",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Jan23/desktoop.gif",
    caption: "Slide 1",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Dec22/new-collection/desktop.gif",
    caption: "Slide 2",
  },
];

export const HomeDetails2 = [
  {
    name: "Blend Edit",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/blend.jpg",
    caption: "Slide 1",
  },
  {
    name: "Air Clip On",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/clipon.jpg",
    caption: "Slide 2",
  },
  {
    name: "Air Flex",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/airflex.jpg",
    caption: "Slide 3",
  },
  {
    name: "Retro Aviator",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/aviator.jpg",
    caption: "Slide 4",
  },
  {
    name: "Round",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/image179.png",
    caption: "Slide 1",
  },
  {
    name: "Cat-Eye",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/cateeye.jpg",
    caption: "Slide 1",
  },
  {
    name: "Clubmaster",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/clubmaster.jpg",
    caption: "Slide 1",
  },
  {
    name: "Transparent",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/trans.jpg",
    caption: "Slide 1",
  },
  {
    name: "Blend Edit",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/blend.jpg",
    caption: "Slide 1",
  },
  {
    name: "Air Clip On",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/clipon.jpg",
    caption: "Slide 1",
  },
  {
    name: "Air Flex",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/airflex.jpg",
    caption: "Slide 1",
  },
  {
    name: "Retro Aviator",
    img: "https://static1.lenskart.com/media/desktop/img/Sep21/aviator.jpg",
    caption: "Slide 1",
  },
];

export const HomeDetails4 = [
  {
    img: "https://static1.lenskart.com/media/desktop/img/June22/contact-lens-more.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/June22/contact-lens-more-1.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails5 = [
  {
    img: "https://static1.lenskart.com/media/desktop/img/Aug21/Desktop/call1800.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Nov21/whatsapp.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Aug21/Desktop/hto.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static1.lenskart.com/media/desktop/img/Aug21/Desktop/stores.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails6 = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e13046-c5-eyeglasses_G_9427.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/sand-dune-full-rim-hustlr-eyeglasses_csvfile-1672134506028-g_6941_12_13_22.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-la-e13032-c1-eyeglasses_g_1999.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-e13046-c5-eyeglasses_G_9427.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/sand-dune-full-rim-hustlr-eyeglasses_csvfile-1672134506028-g_6941_12_13_22.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/e/lenskart-air-la-e13032-c1-eyeglasses_g_1999.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails7 = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-s14944-c1-sunglasses_g_9048_06_09_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/black-silver-blue-gradient-full-rim-wayfarer-vincent-chase-polarized-tinted-vc-s11110-c11-sunglasses_g_2347_9_27_22.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/gold-black-brown-gradient-full-rim-aviator-vincent-chase-polarized-vintage-vc-s13110-c9-sunglasses_g_3766_7_05_22.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-vc-s14944-c1-sunglasses_g_9048_06_09_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/black-silver-blue-gradient-full-rim-wayfarer-vincent-chase-polarized-tinted-vc-s11110-c11-sunglasses_g_2347_9_27_22.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//v/i/gold-black-brown-gradient-full-rim-aviator-vincent-chase-polarized-vintage-vc-s13110-c9-sunglasses_g_3766_7_05_22.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails8 = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/blue-block-phone-&-computer-glasses:-purple-pink-purple-full-rim-round-kids-(8-12-yrs)-hooper-computer-glasses-hp-d10044l-c1_g_374130-may.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/blue-block-phone-&-computer-glasses:-black-full-rim-round-kids-(8-12-yrs)-hooper-computer-glasses-hp-d10044l-c2_g_379330-may.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/blue-block-phone-&-computer-glasses:-brown-full-rim-rectangle-kids-(8-12-yrs)-hooper-computer-glasses-hp-d10039l-c2_g_376130-may.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/blue-block-phone-&-computer-glasses:-purple-pink-purple-full-rim-round-kids-(8-12-yrs)-hooper-computer-glasses-hp-d10044l-c1_g_374130-may.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/blue-block-phone-&-computer-glasses:-black-full-rim-round-kids-(8-12-yrs)-hooper-computer-glasses-hp-d10044l-c2_g_379330-may.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/blue-block-phone-&-computer-glasses:-brown-full-rim-rectangle-kids-(8-12-yrs)-hooper-computer-glasses-hp-d10039l-c2_g_376130-may.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails9 = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/kids-glasses:blue-transparent-full-rim-rectangle-8-12-yrs-hooper-astra-hooper-c1_kids-glasses_blue-blue-transparent-full-rim-rectangle-8-12-yrs-hooper-astra-hooper-c1_g_8504_25_02_2022_23_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/kids-glasses:pink-transparent-full-rim-square-8-12-yrs-hooper-astra-hooper-c3_kids-glasses_transparent-pink-transparent-full-rim-square-8-12-yrs-hooper-astra-hooper-c3_g_8543_23_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/o/hooper-hp-e10004-c1-eyeglasses_G_5762.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/kids-glasses:blue-transparent-full-rim-rectangle-8-12-yrs-hooper-astra-hooper-c1_kids-glasses_blue-blue-transparent-full-rim-rectangle-8-12-yrs-hooper-astra-hooper-c1_g_8504_25_02_2022_23_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/i/kids-glasses:pink-transparent-full-rim-square-8-12-yrs-hooper-astra-hooper-c3_kids-glasses_transparent-pink-transparent-full-rim-square-8-12-yrs-hooper-astra-hooper-c3_g_8543_23_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//h/o/hooper-hp-e10004-c1-eyeglasses_G_5762.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails10 = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/matte-black-half-rim-rectangle-lenskart-readers-lr-e13699-c1-b-reading-eyeglasses-(only-for--1.50-power)_g_826205_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/black-rectangle-lenskart-readers-lr-e11058-c3d-reading-eyeglass-(only-for--2.50-power)_g_409905_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/black-full-rim-rectangle-lenskart-readers-lr-e11058-c4-a-reading-eyeglasses-(only-for--1.25-power)_g_1943_6_16_22.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/matte-black-half-rim-rectangle-lenskart-readers-lr-e13699-c1-b-reading-eyeglasses-(only-for--1.50-power)_g_826205_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/black-rectangle-lenskart-readers-lr-e11058-c3d-reading-eyeglass-(only-for--2.50-power)_g_409905_03_2022.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//l/i/black-full-rim-rectangle-lenskart-readers-lr-e11058-c4-a-reading-eyeglasses-(only-for--1.25-power)_g_1943_6_16_22.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails11 = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/q/aqualens-24-h-nt-daily-dis-toric-20lens_g_3984.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/q/aqualens-24-h-nxt-monly-dis-con-3lens_g_1202.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/q/aqualens-10h-montly-3lns-contact-lens_g_1197.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/q/aqualens-24-h-nt-daily-dis-toric-20lens_g_3984.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/q/aqualens-24-h-nxt-monly-dis-con-3lens_g_1202.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/q/aqualens-10h-montly-3lns-contact-lens_g_1197.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails12 = [
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/i/aquacolor-honey-brown-monthly-color-(2-lenses/box)_2rolloverx_21.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/i/aquacolor-honey-brown-monthly-color-(2-lenses/box)_2rolloverx_21.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/i/aquacolor-honey-brown-monthly-color-(2-lenses/box)_2rolloverx_21.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/i/aquacolor-honey-brown-monthly-color-(2-lenses/box)_2rolloverx_21.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/i/aquacolor-honey-brown-monthly-color-(2-lenses/box)_2rolloverx_21.jpg",
    caption: "Slide 4",
  },
  {
    img: "https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/371x178/9df78eab33525d08d6e5fb8d27136e95//a/i/aquacolor-honey-brown-monthly-color-(2-lenses/box)_2rolloverx_21.jpg",
    caption: "Slide 4",
  },
];

export const HomeDetails14 = [
  {
    img: "https://youtu.be/HYPqf_eVvvM?t=11",
    caption: "Slide 4",
  },
  {
    img: "https://youtu.be/SQm3RxXRunw",
    caption: "Slide 4",
  },
  {
    img: "https://youtu.be/IZpUQ-S_LcM",
    caption: "Slide 4",
  },
];
